// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__NTBea","noInteraction":"EventWrapper_noInteraction__1-QNr","pointerPassthrough":"EventWrapper_pointerPassthrough__2JgKH"};